import { createContext } from "react";
import { useGetOrderQuery } from "src/api/services/ordersApi";
import { OrderWithPrescription } from "src/api/types";
import Spinner from "src/components/Spinner";

export const OrderContext = createContext<OrderWithPrescription | undefined>(
  undefined
);

interface Props {
  children: React.ReactNode;
  orderId: number;
}

const OrderProvider = ({ children, orderId }: Props) => {
  const { data, isLoading } = useGetOrderQuery(orderId);

  if (isLoading == true) {
    return <Spinner />;
  }

  return (
    <OrderContext.Provider value={data} key={data?.id}>
      {children}
    </OrderContext.Provider>
  );
};

export default OrderProvider;
